import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/content";
import { IMG } from "@/data/site";

type Pair = { id: string; title: string; before: string; after: string };
const FALLBACK: Pair[] = [{ id: "sample", title: "", before: IMG.prep, after: IMG.shine }];

export default function BeforeAfter() {
  const [pairs, setPairs] = useState<Pair[]>(FALLBACK);
  const [active, setActive] = useState(0);
  const [pos, setPos] = useState(50);

  useEffect(() => {
    api.get("/before-after").then((r) => {
      if (r.data.length) setPairs(r.data.map((p: any) => ({ id: p.id, title: p.title, before: mediaUrl(p.before_id), after: mediaUrl(p.after_id) })));
    }).catch(() => {});
  }, []);

  const p = pairs[active] || pairs[0];
  return (
    <div>
      <div className="relative aspect-[16/9] w-full select-none overflow-hidden border border-slate-800" data-testid="before-after">
        <img src={p.after} alt={`${p.title || "Project"} after`} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={p.before} alt={`${p.title || "Project"} before`} className={`absolute inset-0 h-full w-full object-cover ${p.id === "sample" ? "grayscale" : ""}`} />
        </div>
        <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-brand-500" style={{ left: `${pos}%` }}>
          <div className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-500 px-2 py-1 font-mono text-xs font-bold text-black">◀ ▶</div>
        </div>
        <span className="absolute left-4 top-4 bg-black/70 px-2 py-1 font-mono text-xs uppercase text-white">Before</span>
        <span className="absolute right-4 top-4 bg-brand-500 px-2 py-1 font-mono text-xs uppercase text-black">After</span>
        {p.title && <span className="absolute bottom-4 left-4 bg-black/70 px-2 py-1 text-xs text-white" data-testid="before-after-title">{p.title}</span>}
        <input
          type="range" min={0} max={100} value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          aria-label="Compare before and after"
          data-testid="before-after-slider"
          className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
        />
      </div>
      {pairs.length > 1 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {pairs.map((x, i) => (
            <button key={x.id} onClick={() => { setActive(i); setPos(50); }} data-testid={`before-after-tab-${i}`}
              className={`border px-3 py-1.5 font-mono text-xs uppercase transition-colors ${i === active ? "border-brand-500 bg-brand-500 text-black" : "border-slate-700 text-slate-300 hover:border-brand-500"}`}>
              {x.title || `Project ${i + 1}`}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
